// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var merchantRouter = {
  path: '/merchant',
  component: Layout,
  redirect: '/merchant/classify',
  name: 'Merchant',
  meta: {
    title: '商户',
    icon: 'clipboard'
  },
  children: [{
    path: 'classify',
    name: 'MerchantAlassify',
    component: function component() {
      return import('@/views/merchant/classify');
    },
    meta: {
      title: '商户分类',
      icon: ''
    }
  }, {
    path: 'list',
    name: 'MerchantList',
    component: function component() {
      return import('@/views/merchant/list');
    },
    meta: {
      title: '商户列表',
      icon: ''
    }
  }, {
    path: 'cooperation',
    name: 'MerchantCooperation',
    component: function component() {
      return import('@/views/merchant/cooperation/index');
    },
    meta: {
      title: '合作申请',
      icon: ''
    }
  }, {
    path: 'expired',
    name: 'MerchantExpired',
    component: function component() {
      return import('@/views/merchant/expired');
    },
    meta: {
      title: '证件到期商户',
      icon: ''
    }
  }, {
    path: 'system',
    name: 'MerchantAystem',
    component: function component() {
      return import('@/views/merchant/system');
    },
    meta: {
      title: '商户菜单管理',
      icon: ''
    }
  }, {
    path: 'application',
    name: 'MerchantApplication',
    component: function component() {
      return import('@/views/merchant/application');
    },
    meta: {
      title: '商户入驻申请',
      icon: ''
    }
  }, {
    path: 'supply-chain-apply',
    name: 'MerchantSupplyChainApply',
    component: function component() {
      return import('@/views/merchant/supplyChainApply');
    },
    meta: {
      title: '供应链入驻',
      icon: ''
    }
  }, {
    path: 'type',
    name: 'MerchantType',
    component: function component() {
      return import('@/views/merchant/type');
    },
    meta: {
      title: '店铺类型',
      icon: 'clipboard'
    },
    children: [{
      path: 'list',
      component: function component() {
        return import('@/views/merchant/type/list');
      },
      name: 'MerchantTypeList',
      meta: {
        title: '店铺类型',
        icon: ''
      }
    }]
  }, {
    path: 'cashier',
    name: 'MerchantCashier',
    component: function component() {
      return import('@/views/merchant/cashier');
    },
    meta: {
      title: '收银台',
      icon: 'clipboard'
    },
    children: [{
      path: 'list',
      component: function component() {
        return import('@/views/merchant/cashier/list');
      },
      name: 'MerchantCashierList',
      meta: {
        title: '门店管理',
        icon: ''
      }
    }, {
      path: 'orderList',
      component: function component() {
        return import('@/views/merchant/cashier/orderList');
      },
      name: 'MerchantCashierOrderList',
      meta: {
        title: '门店订单',
        icon: ''
      }
    }, {
      path: 'orderList/detail/:id?',
      component: function component() {
        return import('@/views/merchant/cashier/orderList/detail');
      },
      name: 'MerchantCashierOrderDetail',
      meta: {
        title: '订单详情',
        icon: '',
        activeMenu: '/merchant/cashier/orderList'
      },
      hidden: true
    }]
  }]
};
export default merchantRouter;